var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('ViewBar',{attrs:{"hidden":true}}),_c('div',[_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":""},slot:"extension",model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}},[_vm._l((_vm.configurationTabs),function(ref){
var key = ref.key;
var label = ref.label;
return _c('v-tab',{key:key,attrs:{"href":("#tab-" + key),"id":("tab-link-" + key)},on:{"click":function($event){return _vm.click(key)}}},[_vm._v(_vm._s(_vm.$t(label)))])}),_vm._l((_vm.configurationTabs),function(ref){
var key = ref.key;
var label = ref.label;
var component = ref.component;
return _c('v-tab-item',{key:key,attrs:{"value":("tab-" + key)}},[_c(component,{tag:"component"})],1)})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }